const actions = {
    common: {
        init: 'init',
        closeModal: 'common-close-modal'
    },
    navigation: {
        setUnsafe: 'navigation-set-unsafe',
        execute: 'navigation-execute',
        reportConfigSection: 'navigation-report-config-section',
        expand: 'expand',
        navigateToItem: 'navigate-to-item'
    },
    grid: {
        refresh: 'grid-refresh'
    },
    operandModal: {
        change: 'operand-modal-change',
        save: 'operand-modal-save'
    },
    copyFieldModal: {
        change: 'field-copy-modal-change',
        save: 'field-copy-modal-save'
    },
    copyReportConfigModal: {
        open: 'copy-report-config-modal-open',
        saveSuccess: 'copy-report-config-modal-save-success'
    },
    copyIngestionConfigModal: {
        open: 'copy-ingestion-config-modal-open',
        saveSuccess: 'copy-ingestion-config-modal-save-success'
    },
    copyAggregationFieldModal: {
        change: 'copy-aggregation-field-modal-change',
        save: 'copy-aggregation-field-modal-save'
    },
    actionItemModal: {
        open: 'action-item-modal-open',
        saveSuccess: 'action-item-modal-save-success'
    },
    complianceCommentModal: {
        open: 'compliance-comment-modal-open',
        saveSuccess: 'compliance-comment-modal-save-success',
        deleteCommentSuccess: 'compliance-comment-modal-delete-success',
        editCommentSuccess: 'compliance-comment-modal-edit-success'
    },
    complianceUrlModal: {
        open: 'compliance-url-modal-open'
    },
    changeLogModal: {
        open: 'change-log-modal-open',
        close: 'change-log-modal-close'
    },
    reportFieldInstructionEditModal: {
        open: 'report-field-instruction-edit-modal-open',
        saveSuccess: 'report-field-instruction-edit-modal-save-success'
    },
    complianceUrlEditModal: {
        open: 'compliance-url-edit-modal-open',
        saveSuccess: 'compliance-url-edit-modal-save-success'
    },
    importReportConfigModal: {
        open: 'import-report-config-modal-open',
        saveSuccess: 'import-report-config-modal-save-success'
    },
    ingestionReplacementModal: {
        open: 'ingestion-replacement-modal-open',
        save: 'ingestion-replacement-modal-save'
    },
    selectors: {
        open: 'selectors-open',
        index: 'index',
        save: 'selectors-save',
        isinChanged: 'isin-changed',
        leiChanged: 'lei-changed',
        exchangeRatesChanged: 'exchange-rates-changed',
        annaDsbUpiEnrichmentChanged: 'anna-dsb-upi-enrichment-changed',
        annaDsbUpiChanged: 'anna-dsb-upi-changed',
        lseChanged: 'lse-changed',
        firdsFcaInstrumentChange: 'first-instrument-changed',
        firdsEsmaInstrumentChange: 'first-instrument-changed',
        fcaRegulatedEntitiesChange: 'fca-regulated-entities-changed',
    },
    copyValidationModal: {
        change: 'validation-copy-modal-change',
        save: 'validation-copy-modal-save'
    },
    copyVariableModal: {
        change: 'variable-copy-modal-change',
        save: 'variable-copy-modal-save'
    },
    createVersionModal: {
        open: 'create-version-modal-open'
    },
    rollBackVersionModal: {
        open: 'rollback-version-modal-open'
    },
    validationChangeLogModal: {
        open: 'validation-change-log-modal-open'
    },
    sessionExpire: {
        warningShowned: 'showned',
        intervalId: 'intervalId'
    },
    component: {
        selected: 'component-selected',
        change: 'component-change'
    },
    editSourceModal: {
        change: 'validation-source-modal-change',
        save: 'validation-source-modal-save'
    },
    editInfoModal: {
        change: 'validation-info-modal-change',
        save: 'validation-info-modal-save'
    },
    transferChangesModal: {
        open: 'transfer-changes-modal-open',
        save: 'transfer-changes-modal-save'
    },
    globalModule: {
        new: 'global-module-new'
    },
    conditionBracket: {
        click: 'condition-bracket-click',
        selectCorrespondingBracket: 'condition-select-corresponding-bracket',
        reset: 'condition-bracket-reset',
        clickMatchingKeyBracket: 'click-matching-key-bracket',
        clickMatchingKeyEndpointBracket: 'click-matching-key-endpoint-bracket',
        clickAggregationBracket: 'click-aggregation-bracket',
        bracketSetInComponent: 'bracket-set-in-component'
    },
    componentChangeLogModal: {
        open: 'component-change-log-modal-open'
    },
    reference: {
        selected: 'reference-selected',
        navigated: 'reference-navigated'
    }
};

export default actions;
